import { Constants } from './shared/Constants';

export class EndPoints {
    public static apiFeedbackVideos: string;

    public static init(): void {
        EndPoints.apiFeedbackVideos = `${Constants.baseApiUrl}/feedback/videos`;
    }
}